import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import IconStyles from "components/icons/Icon.module.scss";

export const HandshakeIcon = ({size, fill, className, id}) => {
  let _attributes = {};
  _attributes.viewBox = "0 0 48 48";
  _attributes.width = _attributes.height = size || 48;
  if (id.trim() !== "") _attributes.id = id;
  if (className) {
    _attributes.className = classnames(IconStyles["icon"], className);
  } else {
    _attributes.className = IconStyles["icon"];
  }

  return (
    <svg {..._attributes}>
      <rect className={IconStyles["icon__canvas"]} x={"0"} y={"0"} width={"48"} height={"48"}/>
      <path id="Marcas2Icone" d="M3.333,1.27a1.111,1.111,0,0,1,0-2.222A1.111,1.111,0,0,1,3.333,1.27ZM28.906.263a2.31,2.31,0,0,1-1.875,3.8,1.225,1.225,0,0,1-.747-.174,2.463,2.463,0,0,1-.868,1.667,2.793,2.793,0,0,1-2.2.764A2.526,2.526,0,0,1,20,7.937a3.1,3.1,0,0,1-2.17.816,5.945,5.945,0,0,1-3.941-1.927L8.733,1.756c-.608-.59-1.3-.486-2.066-.486V-8.175H9.358L12.1-10.918a3.892,3.892,0,0,1,2.743-1.146,7.63,7.63,0,0,1,3.542.365L15.313-8.123a4.23,4.23,0,0,0-.035,5.469,4.745,4.745,0,0,0,7.188.1l2.17-2.431A61.823,61.823,0,0,1,28.906.263Zm2.76,1.007a4.936,4.936,0,0,0-1.042-2.431c-.851-1.094-1.684-2.222-2.552-3.3-.642-.764-1.354-1.51-2.014-2.274A1.115,1.115,0,0,0,24.167-7.81L20.816-4.025a2.546,2.546,0,0,1-3.837-.052A2.021,2.021,0,0,1,17-6.682L20.625-10.9a3.362,3.362,0,0,1,2.535-1.163h2.9a3.935,3.935,0,0,1,2.934,1.319l2.726,3.125h1.615V1.27Zm5,0a1.111,1.111,0,0,1,0-2.222A1.111,1.111,0,0,1,36.667,1.27ZM40-8.73a1.119,1.119,0,0,0-1.111-1.111H32.726c-2-2.292-3.368-4.444-6.667-4.444h-2.9a5.6,5.6,0,0,0-3.142.972,5.6,5.6,0,0,0-3.142-.972H14.844c-3.021,0-4.41,1.875-6.424,3.889H1.111A1.119,1.119,0,0,0,0-9.286V2.381A1.119,1.119,0,0,0,1.111,3.492H7.326l4.983,4.9c2.135,2.1,5.365,3.507,8.229,1.892a4.826,4.826,0,0,0,4.045-1.84,5.285,5.285,0,0,0,3.177-2.2,4.531,4.531,0,0,0,3.594-2.743h7.535A1.119,1.119,0,0,0,40,2.381Z" transform="translate(4 25.286)" fill={fill} />
    </svg>
  );
};
 HandshakeIcon.defaultProps = {
  size: 48,
  fill: "#fff",
  className: "",
  id: ""
};
 HandshakeIcon.propTypes = {
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  fill: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  id: PropTypes.string
};